import React from 'react';
import Info from '../info/info';
import classNames from 'classnames';
import styles from './select.module.scss';

const Select = props => {
  let newProps = { ...props };
  delete newProps['setfieldvalue']; // Here we can delete the props not being used

  return (
    <div className={styles.wrapper + " input-group mb-2"}>
      <select
        onChange={props.onChange}
        onBlur={props.onBlur}
        value={props.value}
        className={
          // hasProps is custom error prop passed from builder.js, stepN.js
          classNames('form-control', { 'is-invalid': props.error })
        }
        name={props.name}
        placeholder={props.placeholder}
        {...newProps}
      >
        <option value="" disabled hidden>
          {props.placeholder ? props.placeholder : 'Select One'}
        </option>
        {props.options.map(option => {
          return (
            <option key={option.value} value={option.value}>
              {option.name}
            </option>
          );
        })}
      </select>
      {props.info ? (
        <div className="input-group-append">
          <Info>{props.info}</Info>
        </div>
      ) : null}
    </div>
  );
};

export default Select;
